import { Field, TextInput, TextArea, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";
import { Switch } from "../ui/switch";

const ICONS = [
  { value: "instagram", label: "Instagram" },
  { value: "youtube", label: "YouTube" },
  { value: "tiktok", label: "TikTok" },
  { value: "facebook", label: "Facebook" },
  { value: "twitter", label: "Twitter / X" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "spotify", label: "Spotify" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "globe", label: "Site / Globe" },
  { value: "shop", label: "Loja" },
  { value: "mail", label: "E-mail" },
  { value: "link", label: "Link genérico" },
];

export default function EditExternalLinks({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setItem = (i, key, v) => {
    const items = [...(value.items || [])];
    items[i] = { ...items[i], [key]: v };
    set("items", items);
  };
  const add = () =>
    set("items", [...(value.items || []), { label: "Novo Link", url: "https://", description: "", icon: "link", enabled: true }]);
  const remove = (i) => set("items", (value.items || []).filter((_, idx) => idx !== i));
  const moveUp = (i) => {
    if (i === 0) return;
    const items = [...(value.items || [])];
    [items[i - 1], items[i]] = [items[i], items[i - 1]];
    set("items", items);
  };
  const moveDown = (i) => {
    const items = [...(value.items || [])];
    if (i >= items.length - 1) return;
    [items[i], items[i + 1]] = [items[i + 1], items[i]];
    set("items", items);
  };

  return (
    <SectionCard title="Links Externos (Linktree / Redes Sociais)">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="external-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="external-title-input" /></Field>
        <Field label="Subtítulo"><TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={2} testId="external-subtitle-input" /></Field>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Links</span>
            <ListAddBtn onClick={add} label="Adicionar link" testId="external-add" />
          </div>
          <p className="text-xs text-onyx/40 mb-4">
            Use o interruptor ao lado para ativar ou desativar cada link individualmente, sem precisar removê-lo.
          </p>
          <div className="space-y-3">
            {(value.items || []).map((item, i) => {
              const enabled = item.enabled !== false;
              return (
                <div
                  key={i}
                  data-testid={`external-row-${i}`}
                  className={`border p-4 transition-colors ${
                    enabled ? "border-border bg-white" : "border-border bg-alabaster opacity-60"
                  }`}
                >
                  <div className="flex items-center justify-between mb-3">
                    <label className="flex items-center gap-3 text-sm">
                      <Switch
                        data-testid={`external-enabled-${i}`}
                        checked={enabled}
                        onCheckedChange={(c) => setItem(i, "enabled", c)}
                      />
                      <span className={`text-xs tracking-[0.2em] uppercase font-semibold ${enabled ? "text-gold" : "text-onyx/40"}`}>
                        {enabled ? "Ativo" : "Inativo"}
                      </span>
                    </label>
                    <div className="flex items-center gap-1">
                      <button
                        type="button"
                        onClick={() => moveUp(i)}
                        disabled={i === 0}
                        data-testid={`external-up-${i}`}
                        className="text-onyx/40 hover:text-onyx px-2 py-1 text-xs disabled:opacity-30"
                        aria-label="Mover para cima"
                      >
                        ↑
                      </button>
                      <button
                        type="button"
                        onClick={() => moveDown(i)}
                        disabled={i >= (value.items?.length || 0) - 1}
                        data-testid={`external-down-${i}`}
                        className="text-onyx/40 hover:text-onyx px-2 py-1 text-xs disabled:opacity-30"
                        aria-label="Mover para baixo"
                      >
                        ↓
                      </button>
                      <ListRemoveBtn onClick={() => remove(i)} testId={`external-remove-${i}`} />
                    </div>
                  </div>
                  <div className="grid sm:grid-cols-3 gap-3">
                    <Field label="Ícone">
                      <select
                        data-testid={`external-icon-${i}`}
                        value={item.icon || "link"}
                        onChange={(e) => setItem(i, "icon", e.target.value)}
                        className="w-full px-3 py-2.5 border border-border bg-white text-onyx text-sm focus:outline-none focus:border-gold"
                      >
                        {ICONS.map((ic) => <option key={ic.value} value={ic.value}>{ic.label}</option>)}
                      </select>
                    </Field>
                    <div className="sm:col-span-2">
                      <Field label="Rótulo"><TextInput value={item.label} onChange={(v) => setItem(i, "label", v)} testId={`external-label-${i}`} /></Field>
                    </div>
                  </div>
                  <div className="mt-3"><Field label="URL"><TextInput value={item.url} onChange={(v) => setItem(i, "url", v)} testId={`external-url-${i}`} /></Field></div>
                  <div className="mt-3"><Field label="Descrição (opcional)"><TextInput value={item.description} onChange={(v) => setItem(i, "description", v)} testId={`external-desc-${i}`} /></Field></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
